/**
 * Shared deferred `beforeinstallprompt` for Customer PWA.
 * PwaLifecycle captures the event; Settings gear Install reads the same prompt.
 */

export interface CustomerBeforeInstallPromptEvent extends Event {
  readonly prompt: () => Promise<void>;
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredPrompt: CustomerBeforeInstallPromptEvent | null = null;
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function setCustomerPwaInstallPrompt(
  event: CustomerBeforeInstallPromptEvent | null,
): void {
  deferredPrompt = event;
  notifyListeners();
}

export function peekCustomerPwaInstallPrompt(): CustomerBeforeInstallPromptEvent | null {
  return deferredPrompt;
}

/** Clears and returns the current prompt (after `prompt()` / dismiss). */
export function takeCustomerPwaInstallPrompt(): CustomerBeforeInstallPromptEvent | null {
  const current = deferredPrompt;
  deferredPrompt = null;
  notifyListeners();
  return current;
}

export function subscribeCustomerPwaInstallPrompt(listener: () => void): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

export function resetCustomerPwaInstallPromptStoreForTests(): void {
  deferredPrompt = null;
  listeners.clear();
}
